var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"aside-course"},[_c('router-link',{attrs:{"to":"/course/2"}},[_c('img',{attrs:{"src":require("@/assets/leetcode/leetcode1.png")}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }